import { Component, Inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PaymentsService } from '../../data-access/payments.service';
import { Subject, takeUntil, tap } from 'rxjs';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'equine-ui-nx-mixed-payments-error-popup',
  templateUrl: './mixed-payments-error-popup.component.html',
  styleUrls: ['./mixed-payments-error-popup.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButton
  ],
})
export class MixedPaymentsErrorPopupComponent implements OnInit, OnDestroy {

  public message!: string;
  public reference!: string;

  private unsubscribe$ = new Subject<void>();

  public showMessageAfterRemoval = signal(false);

  constructor(
    public dialogRef: MatDialogRef<MixedPaymentsErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string, reference: string},
    private paymentsService: PaymentsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.message = this.data.message;
    this.reference = this.data.reference;
  }

  payForItemsNow() {
    this.router.navigate(['payments', 'payment-summary']);
    this.dialogRef.close();
  }

  removeItemsInCart() {
    this.paymentsService.removeAllItemsFromCart(this.reference)
      .pipe(
        tap(() => this.paymentsService.getCartSummary(undefined, this.reference).subscribe()),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: () => {
          this.showMessageAfterRemoval.set(true);
        }
      })
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
